<template>
  <div>
    <!-- ============================================================== -->
    <!-- Preloader - style you can find in spinners.css -->
    <!-- ============================================================== -->
    <div class="preloader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <router-view/>
    <modals-container></modals-container>
  </div>
</template>

<script setup>
import api from '@/libs/Api'
import { ModalsContainer } from 'vue-final-modal'
api.initialize()
</script>

<style lang="scss">

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.edit-card {
  width: 1200px;
}

.action-button {
  width: 200px;
}

.card-body {
  padding: 5px !important;
}
</style>
